import { FormattedMessage } from 'react-intl';
import { Outlet, useMatch } from 'react-router-dom';

import { catchAll } from '@sorare/routing';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { LineupsLayoutSwitch } from '@sorare/core/src/components/lineup/LineupsLayoutSwitch';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  NBA_LIVE_PRO_COMPETITIONS,
  NBA_LIVE_PRO_GAMES,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary, navLabels } from '@sorare/core/src/lib/glossary';
import { EnsureTopVisibleOnMount } from '@sorare/core/src/routing/EnsureTopVisibleOnMount';
import RequireAuth from '@sorare/core/src/routing/RequireAuth';

const Layout = () => {
  const onCompetitionsPage = useMatch(catchAll(NBA_LIVE_PRO_COMPETITIONS));

  return (
    <RequireAuth>
      <EnsureTopVisibleOnMount>
        <ContentWithStickyHeader
          header={
            <FullWidthContainer.NoPadding>
              <TabBar fullWidth variant="flat">
                <Tab
                  to={NBA_LIVE_PRO_COMPETITIONS}
                  matches={[catchAll(NBA_LIVE_PRO_COMPETITIONS)]}
                >
                  <FormattedMessage {...glossary.pro} />
                </Tab>
                <Tab
                  to={NBA_LIVE_PRO_GAMES}
                  matches={[catchAll(NBA_LIVE_PRO_GAMES)]}
                >
                  <FormattedMessage {...glossary.games} />
                </Tab>
                {onCompetitionsPage && <LineupsLayoutSwitch />}
              </TabBar>
            </FullWidthContainer.NoPadding>
          }
        >
          <PageHeader text={navLabels.myLineups} disableBackBrowser />
          <Outlet />
        </ContentWithStickyHeader>
      </EnsureTopVisibleOnMount>{' '}
    </RequireAuth>
  );
};

export default Layout;
